/* Scoped, re-render-safe slider controls. Native buying and cart code is unchanged. */
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-ab-prev],[data-ab-next]');
 if(!button)return;
 const id=button.dataset.abNext||button.dataset.abPrev;
 const track=document.getElementById('ab-slider-'+id);
 if(!track)return;
 const first=track.firstElementChild;
 const step=first?first.getBoundingClientRect().width+20:track.clientWidth;
 track.scrollBy({left:(button.hasAttribute('data-ab-next')?1:-1)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});
